export default "__VITE_ASSET__CmmNM9hS__"